// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.src-js-waivers-editor-waiver-airline-relationships-modal-module__form--KzRG5 {
  padding: 15px 0;
}

.src-js-waivers-editor-waiver-airline-relationships-modal-module__label--DwQfM {
  text-align: left;
}

.src-js-waivers-editor-waiver-airline-relationships-modal-module__row--O7_Fv {
  padding-bottom: 15px;
}

.src-js-waivers-editor-waiver-airline-relationships-modal-module__error--JhLB4 {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/js/waivers/editor/waiver-airline-relationships-modal.module.css"],"names":[],"mappings":";AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["\n.form {\n  padding: 15px 0;\n}\n\n.label {\n  text-align: left;\n}\n\n.row {\n  padding-bottom: 15px;\n}\n\n.error {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `src-js-waivers-editor-waiver-airline-relationships-modal-module__form--KzRG5`,
	"label": `src-js-waivers-editor-waiver-airline-relationships-modal-module__label--DwQfM`,
	"row": `src-js-waivers-editor-waiver-airline-relationships-modal-module__row--O7_Fv`,
	"error": `src-js-waivers-editor-waiver-airline-relationships-modal-module__error--JhLB4`
};
export default ___CSS_LOADER_EXPORT___;
